/* eslint-disable no-nested-ternary */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useThemeClassName } from '../../../contexts/ThemeContext';

import styles from '../../../../styles/displays/steps/step.module.scss';

const propTypes = {
    game: PropTypes.shape.isRequired,
    className: PropTypes.string,
    children: PropTypes.node,
};

const defaultProps = { className: null, children: null };

function EndStep({ game, className, children }) {
    const themeClassName = useThemeClassName(styles);

    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                {
                    [className]: className,
                },
            ])}
        >
            <div className={styles.header}>
                <div className={styles.left}>
                    <h1 className={styles.title}>
                        <FormattedMessage
                            defaultMessage="Final leaderboard"
                            description="Display title"
                        />
                    </h1>
                </div>
            </div>
            {game === null ? (
                <p>
                    <FormattedMessage
                        defaultMessage="Select a game to show the final leaderboard."
                        description="Display label"
                    />
                </p>
            ) : (
                children
            )}
        </div>
    );
}

EndStep.propTypes = propTypes;
EndStep.defaultProps = defaultProps;

export default EndStep;
